/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { map, filter } from 'lodash'
import { useSelector } from 'react-redux';
import { useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from  "react-datepicker";
import { es } from 'date-fns/locale/es';
registerLocale('es', es);

function InformacionGeneralMenor(){
    const { catalogos } = useSelector((state) => state.solicitud);
    const [txtfechaNacimiento, settxtfechaNacimiento] = useState("");
    const [textnacionalidad, settextnacionalidad] = useState("");
    const [textapellidoP, settextapellidoP] = useState("");
    const [textapellidoM, settextapellidoM] = useState("");
    const [textnombre, settextnombre] = useState("");
    const [cmbsexo, setcmbsexo] = useState(null);
    const [txtlugarnacimiento, settxtlugarnacimiento] = useState("");
    const [txtnombrepadre, settxtnombrepadre] = useState("");
    const [textapaternopadre, settextapaternopadre] = useState("");
    const [textamaternopadre, settextamaternopadre] = useState("");
    const [textocupacionpadre, settextocupacionpadre] = useState("");
    const [textnombremadre, settextnombremadre] = useState("");
    const [textapaternomadre, settextapaternomadre] = useState("");
    const [textdireccionnino, settextdireccionnino] = useState("");
    const [textocupacionmadre, settextocupacionmadre] = useState("");
    const [textamaternomadre, settextamaternomadre] = useState("");
    const [textcuidadorninioP, settextcuidadorninioP] = useState("");
    const [textcuidadorninioM, settextcuidadorninioM] = useState("");
    const [textcuidadorninioN, settextcuidadorninioN] = useState("");
    const [textsermedicoOtro, settextsermedicoOtro] = useState("");
    const [cmbentidad, setcmbentidad] = useState(null);
    const [cmbmuicipios, setcmbmuicipios] = useState([]);
    const [cmbmunicipioselect, setcmbmunicipioselect] = useState(null);
    const [cmbparentesco, setcmbparentesco] = useState(null);
    const [cmbsermedico, setcmbsermedico] = useState(null);
    const [textcalculomesesanio, settextcalculomesesanio] = useState("");
    const [textdirpediatra, settextdirpediatra] = useState("");
    
    
    return <>
    <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                     Nombre del niño(a)
                </MDTypography>
              </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
                   <Grid item xs={12} md={4} lg={4}>
                    <TextField 
                            value={textapellidoP}
                            onChange={(event)=>{
                                settextapellidoP(event.target.value);
                            }} error={false} helperText=""  
                            label={"A. Paterno"}
                            variant="outlined" 
                            style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                        />
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                    <TextField 
                        value={textapellidoM}
                        onChange={(event)=>{
                            settextapellidoM(event.target.value);
                        }} error={false} helperText=""  
                        label={"A. Materno"}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                    <TextField 
                        value={textnombre}
                        onChange={(event)=>{
                            settextnombre(event.target.value);
                        }} error={false} helperText=""  
                        label={"Nombre"}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
                </Grid>
            </Grid>

          </Grid>
    </Grid>
   <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                    Fecha de Nacimiento
                </MDTypography>
              </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={6}>
                     <TextField 
                        value={txtfechaNacimiento}
                        onChange={(event)=>{
                            settxtfechaNacimiento(event.target.value);
                            settextcalculomesesanio("12 MESES");
                        }} error={false} helperText=""  
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                        type='date'
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                    <TextField 
                        value={textcalculomesesanio}
                        error={false} helperText=""  
                        label={""}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                        disabled={false}
                        color='error'
                    />
                </Grid>
            </Grid>

          </Grid>
    </Grid>
    <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                    Nacionalidad
                </MDTypography>
              </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
             <TextField 
                        value={textnacionalidad}
                        onChange={(event)=>{
                            settextnacionalidad(event.target.value);
                        }} error={false} helperText=""  
                        label={""}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
          </Grid>
    </Grid>
    <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                    Lugar de Nacimiento
                </MDTypography>
              </MDBox>
          </Grid>
           <Grid item xs={12} md={9} lg={9}>
             <TextField 
                        value={txtlugarnacimiento}
                        onChange={(event)=>{
                            settxtlugarnacimiento(event.target.value);
                        }} error={false} helperText=""  
                        label={""}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
          </Grid>
    </Grid>     
       <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                    Sexo
                </MDTypography>
              </MDBox>
          </Grid>
           <Grid item xs={12} md={9} lg={9}>
             <Autocomplete
                options={[
                    {
                        id:0,
                        descripcion: "Masculino"
                    },
                    {
                        id:1,
                        descripcion: "Femenino"
                    }
               ]}
                getOptionLabel={(option) => option.descripcion}
                id="controlled-demo"
                value={cmbsexo}
                onChange={(event, newValue) => {
                    setcmbsexo(newValue);
                }}
                renderInput={(params) => (
                    <TextField {...params} label={"Seleccione"} variant="outlined" error={false}  />
                )}
                style={{width:"100%", marginBottom: "1rem"}}
                size="small"
                                    
            />
          </Grid>
    </Grid>   
    <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                     Nombre de la madre
                </MDTypography>
              </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
                   <Grid item xs={12} md={4} lg={4}>
                    <TextField 
                            value={textapaternopadre}
                            onChange={(event)=>{
                                settextapaternopadre(event.target.value);
                            }} error={false} helperText=""  
                            label={"A. Paterno"}
                            variant="outlined" 
                            style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                        />
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                    <TextField 
                        value={textamaternopadre}
                        onChange={(event)=>{
                             settextamaternopadre(event.target.value);
                        }} error={false} helperText=""  
                        label={"A. Materno"}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                    <TextField 
                        value={txtnombrepadre}
                        onChange={(event)=>{
                             settxtnombrepadre(event.target.value);
                        }} error={false} helperText=""  
                        label={"Nombre"}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
                </Grid>
            </Grid>

          </Grid>
    </Grid> 
    <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                    Ocupación de la madre
                </MDTypography>
              </MDBox>
          </Grid>
           <Grid item xs={12} md={9} lg={9}>
             <TextField 
                        value={textocupacionmadre}
                        onChange={(event)=>{
                            settextocupacionmadre(event.target.value);
                        }} error={false} helperText=""  
                        label={""}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
          </Grid>
    </Grid>  
    <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                     Nombre del padre
                </MDTypography>
              </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
                   <Grid item xs={12} md={4} lg={4}>
                    <TextField 
                            value={textapaternomadre}
                            onChange={(event)=>{
                                settextapaternomadre(event.target.value);
                            }} error={false} helperText=""  
                            label={"A. Paterno"}
                            variant="outlined" 
                            style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                        />
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                    <TextField 
                        value={textamaternomadre}
                        onChange={(event)=>{
                            settextamaternomadre(event.target.value);
                        }} error={false} helperText=""  
                        label={"A. Materno"}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                    <TextField 
                        value={textnombremadre}
                        onChange={(event)=>{
                            settextnombremadre(event.target.value);
                        }} error={false} helperText=""  
                        label={"Nombre"}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
                </Grid>
            </Grid>

          </Grid>
    </Grid> 
    <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                    Ocupación del padre
                </MDTypography>
              </MDBox>
          </Grid>
           <Grid item xs={12} md={9} lg={9}>
             <TextField 
                        value={textocupacionpadre}
                        onChange={(event)=>{
                            settextocupacionpadre(event.target.value);
                        }} error={false} helperText=""  
                        label={""}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
          </Grid>
    </Grid>  
    <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                    Dirección del niño(a)
                </MDTypography>
              </MDBox>
          </Grid>
           <Grid item xs={12} md={9} lg={9}>
             <TextField 
                        value={textdireccionnino}
                        onChange={(event)=>{
                            settextdireccionnino(event.target.value);
                        }} error={false} helperText=""  
                        label={""}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                        multiline
                        rows={3}
                    />
          </Grid>
    </Grid>  
     <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                    Entidad federativa
                </MDTypography>
              </MDBox>
          </Grid>
           <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={6}>
                        <Autocomplete
                            options={catalogos.entidades}
                            getOptionLabel={(option) => option.entidad}
                            id="controlled-demo"
                            value={cmbentidad}
                            onChange={(event, newValue) => {
                                if(!newValue){
                                    setcmbentidad(null);
                                    setcmbmuicipios([]);
                                }else{
                                    setcmbentidad(newValue);
                                    var municipios= filter(catalogos.municipios,(item)=>{return item.idEntidad == newValue.idEntidad});
                                    if(municipios){
                                        setcmbmuicipios(municipios);
                                    }
                                }
                                setcmbmunicipioselect(null);
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label={"Seleccione"} variant="outlined" error={false}  />
                            )}
                            style={{width:"100%", marginBottom: "1rem"}}
                            size="small"
                                                
                        />
                </Grid>
                <Grid item xs={12} md={1} lg={1}>
                        <MDBox textAlign="right">
                        <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                            Municipio
                        </MDTypography>
                    </MDBox>
                </Grid>
                <Grid item xs={12} md={5} lg={5}>
                    <Autocomplete
                        options={cmbmuicipios}
                        getOptionLabel={(option) => option.municipio}
                        id="controlled-demo"
                        value={cmbmunicipioselect}
                        onChange={(event, newValue) => {
                            if(!newValue)
                                setcmbmunicipioselect(null);
                            else
                                setcmbmunicipioselect(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField {...params} label={"Seleccione"} variant="outlined" error={false}  />
                        )}
                        style={{width:"100%", marginBottom: "1rem"}}
                        size="small"
                                            
                    />
                </Grid>
            </Grid>
             
          </Grid>
    </Grid>  
     <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                    Pediatra / Médico 1er Contacto
                </MDTypography>
              </MDBox>
          </Grid>
           <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={6}>
                       <TextField 
                        value={""}
                        onChange={(event)=>{
                            
                        }} error={false} helperText=""  
                        label={""}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
                </Grid>
                <Grid item xs={12} md={1} lg={1}>
                        <MDBox textAlign="right">
                        <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                            Celular
                        </MDTypography>
                    </MDBox>
                </Grid>
                <Grid item xs={12} md={5} lg={5}>
                     <TextField 
                        value={""}
                        onChange={(event)=>{
                            
                        }} error={false} helperText=""  
                        label={""}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
                </Grid>
            </Grid>
             
          </Grid>
    </Grid>  
    <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                    Dirección del pediatra
                </MDTypography>
              </MDBox>
          </Grid>
           <Grid item xs={12} md={9} lg={9}>
             <TextField 
                        value={textdirpediatra}
                        onChange={(event)=>{
                            settextdirpediatra(event.target.value);
                        }} error={false} helperText=""  
                        label={""}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                        multiline
                       rows={3}
                    />
             
          </Grid>
    </Grid> 
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                     Cuidador primario del niño(a)
                </MDTypography>
              </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
                   <Grid item xs={12} md={4} lg={4}>
                    <TextField 
                            value={textcuidadorninioP}
                            onChange={(event)=>{
                                settextcuidadorninioP(event.target.value);
                            }} error={false} helperText=""  
                            label={"A. Paterno"}
                            variant="outlined" 
                            style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                        />
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                    <TextField 
                        value={textcuidadorninioM}
                        onChange={(event)=>{
                            settextcuidadorninioM(event.target.value);
                        }} error={false} helperText=""  
                        label={"A. Materno"}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                    <TextField 
                        value={textcuidadorninioN}
                        onChange={(event)=>{
                            settextcuidadorninioN(event.target.value);
                        }} error={false} helperText=""  
                        label={"Nombre"}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
                </Grid>
            </Grid>

          </Grid>
    </Grid> 
    <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                    Parentesco con el niño(a)
                </MDTypography>
              </MDBox>
          </Grid>
           <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={6}>
                        <Autocomplete
                            options={catalogos.parentescos}
                            getOptionLabel={(option) => option.descripcion}
                            id="controlled-demo"
                            value={cmbparentesco}
                            onChange={(event, newValue) => {
                                if(!newValue){
                                   setcmbparentesco(null);
                                }else{
                                    setcmbparentesco(newValue);
                                }
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label={"Seleccione"} variant="outlined" error={false}  />
                            )}
                            style={{width:"100%", marginBottom: "1rem"}}
                            size="small"
                                                
                        />
                </Grid>
                <Grid item xs={12} md={1} lg={1}>
                        <MDBox textAlign="right">
                        <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                            Especifique
                        </MDTypography>
                    </MDBox>
                </Grid>
                <Grid item xs={12} md={5} lg={5}>
                     <TextField 
                            value={""}
                            onChange={(event)=>{
                                
                            }} error={false} helperText=""  
                            label={""}
                            variant="outlined" 
                            style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                        />
                </Grid>
            </Grid>
             
          </Grid>
    </Grid>  
     <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                    Cuenta con servicio médico
                </MDTypography>
              </MDBox>
          </Grid>
           <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={6}>
                        <Autocomplete
                            options={catalogos.serviciosMedicos}
                            getOptionLabel={(option) => option.descripcion}
                            id="controlled-demo"
                            value={cmbsermedico}
                            onChange={(event, newValue) => {
                                if(!newValue){
                                   setcmbsermedico(null);
                                }else{
                                    setcmbsermedico(newValue);
                                }
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label={"Seleccione"} variant="outlined" error={false}  />
                            )}
                            style={{width:"100%", marginBottom: "1rem"}}
                            size="small"
                                                
                        />
                </Grid>
                <Grid item xs={12} md={1} lg={1}>
                        <MDBox textAlign="right">
                        <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                            Otro
                        </MDTypography>
                    </MDBox>
                </Grid>
                <Grid item xs={12} md={5} lg={5}>
                     <TextField 
                            value={textsermedicoOtro}
                            onChange={(event)=>{
                                settextsermedicoOtro(event.target.value);
                            }} error={false} helperText=""  
                            label={""}
                            variant="outlined" 
                            style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                        />
                </Grid>
            </Grid>
             
          </Grid>
    </Grid> 
    <MDBox textAlign="center">
        <MDTypography variant="h6" color="info" style={{opacity: 0.7, fontSize:14}}>
            *Información para fines estadísticos, no se requiere que renuncies a ningún tipo de servicio médico público o privado.
        </MDTypography>
    </MDBox>
    </>
}

export default InformacionGeneralMenor;